/* @ngInject */
const myAreaPie = (
  wagonFields
) => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myAreaPie.html'),
    /* @ngInject */
    controller: ($scope, $$area) => {
      const init = async () => {
        $scope.areaPieLabels = ['Longueur utilisée (m)', 'Longueur restante (m)',]
        const areas = (await $$area.request.getAll()).areas
        const realAreas = areas.filter(area => area.isReal)
        const usedLength = realAreas
          .reduce((total, area) => total + area.usedLength, 0)
        const availableLength = realAreas
          .reduce((total, area) => total + area.availableLength, 0)

        $scope.areaPieData = [
          Math.round(usedLength, 2),
          Math.round(availableLength, 2),
        ]

        const areasUsed = realAreas.map(area => area.usedLength)
        const areasAvailable = realAreas.map(area => area.availableLength)
        const areasNames = realAreas.map(area => area.name)

        $scope.areasPieData = []
        $scope.areasPieLabels = []

        for (let index = 0; index < areasUsed.length; index++) {
          const used = areasUsed[index]
          const available = areasAvailable[index]
          const name = areasNames[index]

          $scope.areasPieData.push(Math.round(used, 2))
          $scope.areasPieData.push(Math.round(available, 2))
          $scope.areasPieLabels.push(`${name} utilisée`)
          $scope.areasPieLabels.push(`${name} disponible`)
        }
      }

      init()
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myAreaPie



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/stat/myAreaPie.js